import { apiDateToDate } from "../utils/dateConverters";

/**
 * Maps GET /api/timelines/:id `data` to a stable view model (IRL dates as Date).
 * Single place that knows the API wire shape for timeline detail.
 */
export function normalizeTimelineViewModel(apiData) {
  if (!apiData) return null;
  const lanes = [...(apiData.lanes || [])]
    .map((l) => ({
      id: l.id,
      name: l.name,
      sortOrder: l.sortOrder ?? 0,
    }))
    .sort((a, b) => a.sortOrder - b.sortOrder);
  const items = (apiData.items || []).map((it) => ({
    type: it.type,
    id: it.id,
    name: it.name,
    startDate: apiDateToDate(it.startDate),
    endDate: it.endDate ? apiDateToDate(it.endDate) : null,
    laneId: it.laneId,
    isEra: Boolean(it.isEra),
    startEventId: it.startEventId ?? null,
    endEventId: it.endEventId ?? null,
  }));
  return {
    id: apiData.id,
    name: apiData.name,
    description: apiData.description,
    authorPseudo: apiData.authorPseudo,
    filters: apiData.filters,
    lanes,
    items,
  };
}

/**
 * Builds PUT /api/timelines/:id/layout body. Omit `id` for new lanes (server assigns UUID v7).
 */
export function buildLayoutPayload(lanes, items) {
  const lanesPayload = lanes.map((l, i) => {
    const row = { name: l.name, sortOrder: l.sortOrder ?? i };
    if (l.id != null && l.id !== "") {
      row.id = l.id;
    }
    return row;
  });
  const placements = items.map((it) => {
    const row = {
      itemType: it.type,
      itemId: it.id,
      laneId: it.laneId,
    };
    if (it.type === "period") {
      row.isEra = Boolean(it.isEra);
    }
    return row;
  });
  return { lanes: lanesPayload, placements };
}
